import { Injectable } from '@angular/core';
import { ResourcesService } from '../resources.service';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../user/user.service';
import {Partner} from '../../model/partner';
import {Product} from '../../model/product';
import {Agent} from '../../model/agent';
import * as moment from 'moment';

@Injectable()
export class AgentService {
  suppliers: any[];
  suppliersStamp: moment.Moment;
  updateSuppliersTimeout = setTimeout(() => {}, 0);
  gettingSuppliers = false;

  constructor(
    private _resources: ResourcesService,
    private _user: UserService) { }

  getPhysicalAgent(): Observable<any> {
    return this._resources.get('agent/get');
  }

  getAgentResume(): Observable<any[]> {
    return this._resources.get('agent/Resume?agentId=' + this._user.userAccountTypeDefault.agent.id);
  }

  getAgentResumeToSupplier(supplierId: string | number): Observable<any[]> {
    return this._resources.get(
      'agent/ResumeToSupplier?agentId=' + this._user.userAccountTypeDefault.agent.id
      + '&supplierId=' + supplierId);
  }

  updateSuppliers(force = false): Promise<any[]> {
    return new Promise((resolve, reject) => {
      if (this.gettingSuppliers) {
        this._setUpdateTimeout(resolve);
      } else if (!this.suppliers || force || !this.suppliersStamp || moment().diff(this.suppliersStamp, 'seconds') > 2) {
        this.gettingSuppliers = true;
        this.suppliersStamp = moment();
        this.getAgentResume().subscribe(
          (res: any) => this.suppliers = res.suppliers,
          () => reject('Error retrieving suppliers!'),
          () => {
            this.gettingSuppliers = false;
            resolve(this.suppliers);
          }
        );
      } else {
        resolve(this.suppliers);
      }
    });
  }

  private _setUpdateTimeout(resolve: (value?: any) => void) {
    this.updateSuppliersTimeout = setTimeout(() => {
      if (this.gettingSuppliers) {
        clearTimeout(this.updateSuppliersTimeout);
        this._setUpdateTimeout(resolve);
      } else {
        resolve(this.suppliers);
      }
    }, 500);
  }

  getSuppliers(): Observable<Partner[]> {
    return this._resources.get('agent/GetSuppliers?agentId=' + this._user.userAccountTypeDefault.agent.id);
  }

  getSupplier(supplierId: any): Observable<Partner> {
    return this._resources.get('agent/GetSupplierById?agentId=' + this._user.userAccountTypeDefault.agent.id + '&supplierId=' + supplierId);
  }

  getProduct(supplierId: any, productId: any): Observable<any> {
    return this._resources.get(
      'agent/GetProductById?agentId=' + this._user.userAccountTypeDefault.agent.id
      + '&supplierId=' + supplierId
      + '&productId=' + productId);
  }

  getProducts(supplierId: any): Observable<Product[]> {
    return this._resources.get('agent/GetProducts?agentId=' + this._user.userAccountTypeDefault.agent.id + '&supplierId=' + supplierId);
  }

  getEvent(supplierId: any, eventId: any): Observable<any> {
    return this._resources.get(
      'agent/GetEventById?agentId=' + this._user.userAccountTypeDefault.agent.id
      + '&supplierId=' + supplierId
      + '&eventId=' + eventId);
  }

  getEventsNextTop(supplierId: any, productId: any, top = 10): Observable<any> {
    return this._resources.get(
      'agent/GetEventsNextTop?agentId=' + this._user.userAccountTypeDefault.agent.id
      + '&supplierId=' + supplierId
      + '&productId=' + productId
      + '&top=' + top);
  }

  getEvents(supplierId: string, from = '', to = ''): Observable<any> {
    let url = 'agent/GetEvents?agentId=' + this._user.userAccountTypeDefault.agent.id + '&supplierId=' + supplierId;
    if (from !== '') {
      url += '&dtFrom=' + from;
    }
    if (to !== '') {
      url += '&dtTo=' + to;
    }
    return this._resources.get(url);
  }

  getEventsByProduct(supplierId: any, productId: any, from = '', to = ''): Observable<any> {
    let url = 'agent/GetEventsByProduct?agentId=' + this._user.userAccountTypeDefault.agent.id +
      '&supplierId=' + supplierId + '&productId=' + productId;
    if (from !== undefined) {
      url += '&dtFrom=' + from;
    }
    if (to !== undefined) {
      url += '&dtTo=' + to;
    }
    return this._resources.get(url);
  }

  getCalendar(supplierId: number | string, dtFrom?: string, dtTo?: string, pax?: number | string) {
    let url = 'agent/GetCalendar?agentId=' + this._user.userAccountTypeDefault.agent.id +
      '&supplierId=' + supplierId;
    if (dtFrom !== undefined) {
      url += '&dtFrom=' + dtFrom;
    }
    if (dtTo !== undefined) {
      url += '&dtTo=' + dtTo;
    }
    if (pax !== undefined) {
      url += '&pax=' + pax;
    }
    return this._resources.get(url);
  }

  downloadTicket(bookingId: number | string, supplierId: number | string): Observable<any> {
    return this._resources.get('agent/DownloadTicket?supplierId=' + supplierId +
      '&bookingId=' + bookingId + '&agentId=' + this._user.userAccountTypeDefault.agent.id);
  }

  sendTicket(bookingId: number | string, supplierId: number | string): Observable<any> {
    return this._resources.get(
      'agent/ticket/send?agentId=' + this._user.userAccountTypeDefault.agent.id +
      '&supplierId=' + supplierId +
      '&bookingId=' + bookingId
    );
  }

  acceptProtocol(notificationId: number | string) {
    return this._resources.get('agent/AcceptProtocol?id=' + notificationId);
  }

  updateProfile(agent: Agent): Observable<Agent> {
    return this._resources.post('agent/UpdateProfile', agent);
  }

  getAgentCommissions(supplierId: number | string, agentId: number | string) {
    return this._resources.get(
      'people/GetAgentCommissions?supplierId=' + supplierId + '&agentId=' + agentId
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/agent/agent.service.ts